import { useState, useEffect } from 'react';
import Fifth from './Pages/Fifth';
import Fourth from "./Pages/Fourth";
import Third from "./Pages/Third";
import Second from "./Pages/Second";
import First from "./Pages/First";
import InstaFirst from './Pages/InstaFirst';
import InstaSecond from './Pages/InstaSecond';
import InstaThird from './Pages/InstaThird';
import InstaFourth from './Pages/InstaFourth';
import UGC from './Pages/UGC';
import { decrypt } from '../utils/cryptoUtils';
import logo from "../assets/logo.png";
import google from "../assets/google.png";
import { AiFillStar } from "react-icons/ai";
import bg from "../assets/bg.jpeg";
import ReviewRating from "./new/Google/ReviewRating";
import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';
import LuckyDay from './Pages/LuckyDay';
import VideoAds from './Pages/VideoAds';
import c1 from "../assets/c2 (1).mp4";
import c2 from "../assets/c2 (2).mp4";
import NewReview from './Pages/NewReview';
import caratlane1 from "../assets/portrait.mp4";
import caratlane2 from "../assets/caratlane2.mp4";
import content from "../assets/c1.mp4"
import NewPosts from './Pages/NewPosts';
import loader from "../assets/loader.gif"
import QRCode from 'qrcode.react';
import ig from "../assets/ig-header.png"

function NewLayout() {
  const urlParams = new URLSearchParams(window.location.search);
  const storecode = urlParams.get("storeCode");
  const [status, setStatus] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [posts, setPosts] = useState([]);
  const [branchInfo, setBranchInfo] = useState([]);
  const [showReviews, setShowReviews] = useState([]);
  const [showIg, setShowIg] = useState([]);
  const [showUgc, setShowUgc] = useState([]);
  const [ind, setInd] = useState(0);
  const [indUgc, setIndUgc] = useState(0);
  const [ugc, setUgc] = useState([]);
  const [video, setVideo] = useState([]);
  const [index, setIndex] = useState(0);
  const [lastPostTime,setLastPostTime] = useState(localStorage.getItem("GooglePostTime")?localStorage.getItem("GooglePostTime"):"")
  const [lastInstaPostTime,setLastInstaPostTime] = useState(localStorage.getItem("InstaPostTime")?localStorage.getItem("InstaPostTime"):"")
  const [showModal, setShowModal] = useState(false)
  const [recent,setRecent] = useState([])
  const [queue, setQueue] = useState([]);
  const [showModalInsta, setShowModalInsta] = useState(false)
  const [recentInsta,setRecentInsta] = useState([])
  const [queueInsta, setQueueInsta] = useState([]);
  const [duration, setDuration] = useState(0);
  const [color, setColor] = useState('');
  const [instaDetailTime,setInstaDetailTime] = useState(localStorage.getItem("InstaDetailTime")?localStorage.getItem("InstaDetailTime"):"")
  const [googleDetailTime,setGoogleDetailTime] = useState(localStorage.getItem("GoogleDetailTime")?localStorage.getItem("GoogleDetailTime"):"")
  const [loading,setLoading] = useState(false)
  const [widgetData, setWidgetData] = useState({
    "Content": {"UpdateTime": 0, "Count": 0},
    "Instagram": {"UpdateTime": 0, "Count": 0},
    "GoogleReview": {"UpdateTime": 0, "Count": 0}
  });
  const [reviewIndex,setReviewIndex] = useState(0)
  const [igIndex,setIgIndex] = useState(0)
  
  const fetchReviews = async () => {
    try {
      setLoading(true);
      const requestBody = new URLSearchParams();
      requestBody.append('BranchId', storecode);
      
      requestBody.append('GoogleDetailTime',googleDetailTime!=="undefined"?googleDetailTime:"")
      requestBody.append('GoogleLastPostTime',lastPostTime!=="undefined"?lastPostTime:"")
      requestBody.append('InstaLastPostTime',lastInstaPostTime!=="undefined"?lastInstaPostTime:"")
      requestBody.append('InstaDetailTime',instaDetailTime!=="undefined"?instaDetailTime:"")

      const reviewsResponse = await fetch('https://api-digitalwall.xploro.io/Digitalwall/DigitalwallDetailsWeb', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: requestBody,
      });

      if (!reviewsResponse.ok) {
        const errorData = await reviewsResponse.json();
        throw new Error(`Reviews request error! Status: ${reviewsResponse.status}, Details: ${JSON.stringify(errorData)}`);
      }

      const reviewsData = await reviewsResponse.json();
      localStorage.setItem("BusinessName",reviewsData.config.BranchInfo.BusinessName)
      setBranchInfo(reviewsData.config.BranchInfo);
      setReviews(reviewsData.Data.GoogleReviews);
      setPosts(reviewsData.Data.InstaPostsImage);
      setUgc(reviewsData.Data.Content);
      setVideo(reviewsData.Data.InstaPostsVideo);
      setLoading(false);

      if(localStorage.getItem("GooglePostTime")===null){
        localStorage.setItem("GooglePostTime",reviewsData.Data.GoogleReviews[0]?.ReviewTime)
        localStorage.setItem("InstaPostTime",reviewsData.Data.InstaPostsImage[0]?.PostTime)
        setLastPostTime(reviewsData.Data.GoogleReviews[0]?.ReviewTime)
        setLastInstaPostTime(reviewsData.Data.InstaPostsImage[0]?.PostTime)
      }

        setGoogleDetailTime(reviewsData.Data.GoogleReviews[reviewsData.Data.GoogleReviews.length-1]?.ReviewTime)
        localStorage.setItem("GoogleDetailTime",reviewsData.Data.GoogleReviews[reviewsData.Data.GoogleReviews.length-1]?.ReviewTime)
        localStorage.setItem("InstaDetailTime",reviewsData.Data.InstaPostsImage[reviewsData.Data.InstaPostsImage.length-1]?.PostTime)
        setInstaDetailTime(reviewsData.Data.InstaPostsImage[reviewsData.Data.InstaPostsImage.length-1]?.PostTime)
      
      setColor(reviewsData.config.BranchInfo.ColorTheme)
      const backgroundStyle = (reviewsData.config.BranchInfo.BusinessName === "Drive X Mobility " || reviewsData.config.BranchInfo.BusinessName === "DriveX")
      ? "linear-gradient(to right, #64469B, #F47823)"
      : reviewsData.config.BranchInfo.ColorTheme;
    
      document.documentElement.style.setProperty('--dynamic-color', backgroundStyle);
      
      const parsedData = JSON.parse(reviewsData.config.BranchInfo.WidgetConf);
      setWidgetData(parsedData);

      if(reviewsData.Data.LatestData.Reviews[0]){
        setLastPostTime(reviewsData.Data.LatestData.Reviews[0].ReviewTime);
        localStorage.setItem("GooglePostTime",reviewsData.Data.LatestData.Reviews[0].ReviewTime);
        setRecent(reviewsData.Data.LatestData.Reviews);
        setQueue(prevQueue => [...prevQueue, ...reviewsData.Data.LatestData.Reviews]);
        
        setShowModal(true);
      }
      if(reviewsData.Data.LatestData.InstaPosts[0] && reviewsData.config.BranchInfo.BusinessName!=="Caratlane"){
        setLastInstaPostTime(reviewsData.Data.LatestData.InstaPosts[0].PostTime);
        localStorage.setItem("InstaPostTime",reviewsData.Data.LatestData.InstaPosts[0].PostTime)
        setRecentInsta(reviewsData.Data.LatestData.InstaPosts);
        setQueueInsta(prevQueue => [...prevQueue, ...reviewsData.Data.LatestData.InstaPosts]); 
        
        setShowModalInsta(true);
      }

    } catch (error) {
      console.error('Error fetching reviews:', error.message);
    }
  };

  useEffect(() => {
    if ((widgetData["GoogleReview"]?.Count||widgetData["Instagram"]?.Count)&&status === 0) {
      setStatus(1);
      setShowReviews(reviews?.slice(index, index + widgetData["GoogleReview"]?.Count));
      console.log(widgetData);
      setIndex(index + widgetData["GoogleReview"]?.Count);
      setShowIg(posts?.slice(ind, ind + widgetData["Instagram"]?.Count));
      setInd(ind + widgetData["Instagram"]?.Count);
      setShowUgc(ugc?.slice(indUgc, indUgc + 2));
      setIndUgc(indUgc + 2);
    }
  }, [widgetData, reviews, posts, ugc, index, ind, status]);

  useEffect(() => {

  if(showModal){
    const timerToHideModal = setTimeout(() => {
      setShowModal(false);
    }, 10000);
    return () => {
      clearTimeout(timerToHideModal);
    };
  }
   
  }, [showModal]);

  useEffect(() => {

    if(showModalInsta){
      const timerToHideModal = setTimeout(() => {
        setShowModalInsta(false);
      }, 10000);
      return () => {
        clearTimeout(timerToHideModal);
      };
    }
     
    }, [showModalInsta]);

  const fetchReviews2 = async () => {
    try {
      const requestBody = new URLSearchParams();
      requestBody.append('BranchId', storecode);

    
      requestBody.append('GoogleDetailTime',googleDetailTime!=="undefined"?googleDetailTime:"")
      requestBody.append('GoogleLastPostTime',lastPostTime!=="undefined"?lastPostTime:"")
      requestBody.append('InstaLastPostTime',lastInstaPostTime!=="undefined"?lastInstaPostTime:"")
      requestBody.append('InstaDetailTime',instaDetailTime!=="undefined"?instaDetailTime:"")
      

      const reviewsResponse = await fetch('https://api-digitalwall.xploro.io/Digitalwall/DigitalwallDetailsWeb', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: requestBody,
      });

      if (!reviewsResponse.ok) {
        const errorData = await reviewsResponse.json();
        throw new Error(`Reviews request error! Status: ${reviewsResponse.status}, Details: ${JSON.stringify(errorData)}`);
      }

      const reviewsData = await reviewsResponse.json();
      // setReviews(reviewsData.Data.GoogleReviews);
      // setPosts(reviewsData.Data.InstaPostsImage);
      if(reviewsData.Data.LatestData.Reviews[0]){
        setLastPostTime(reviewsData.Data.LatestData.Reviews[0].ReviewTime);
        localStorage.setItem("GooglePostTime",reviewsData.Data.LatestData.Reviews[0].ReviewTime);
        setRecent(reviewsData.Data.LatestData.Reviews);
        setQueue(prevQueue => [...prevQueue, ...reviewsData.Data.LatestData.Reviews]);
        
        setShowModal(true);
      }

      if(reviewsData.Data.LatestData.InstaPosts[0] && reviewsData.config.BranchInfo.BusinessName!=="Caratlane"){
        setLastInstaPostTime(reviewsData.Data.LatestData.InstaPosts[0].PostTime);
        localStorage.setItem("InstaPostTime",reviewsData.Data.LatestData.InstaPosts[0].PostTime)
        setRecentInsta(reviewsData.Data.LatestData.InstaPosts);
        setQueueInsta(prevQueue => [...prevQueue, ...reviewsData.Data.LatestData.InstaPosts]); 
        
        setShowModalInsta(true);
      }
      
     
    } catch (error) {
      console.error('Error fetching reviews:', error.message);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  useEffect(()=>{
    const intervalId = setInterval(fetchReviews2, 20000); 
    return () => clearInterval(intervalId);
  },[lastInstaPostTime,lastPostTime])

  useEffect(() => {
    if (queue.length > 0) {
      const timer = setTimeout(() => {
        setRecent(prevRecent => prevRecent?.slice(1)); 
        setQueue(prevQueue => prevQueue?.slice(1));
        setShowModal(true); 
      }, 15000); 

      return () => clearTimeout(timer);
    }
  }, [queue]);

  useEffect(() => {
    if (queueInsta.length > 0) {
      const timer = setTimeout(() => {
        setRecentInsta(prevRecent => prevRecent?.slice(1)); 
        setQueueInsta(prevQueue => prevQueue?.slice(1));
        setShowModalInsta(true); 
      }, 15000); 

      return () => clearTimeout(timer);
    }
  }, [queueInsta]);

  const preloadUrls = (data) => {
    if (!Array.isArray(data)) {
      console.log("Data is not an array");
      return;
    }
  
    data.forEach((item) => {
      if (!item || !item.MediaURL) {
        console.log("Media URL data is missing or invalid in an item");
        return;
      }
  
      const insta = new Image();
      insta.crossOrigin = "anonymous";
      insta.src = item.MediaURL;
    });
  };  

  useEffect(()=>{
    preloadUrls(posts);
  },[posts,ugc])
  

  useEffect(() => {
 

    const timeout2 = setTimeout(() => {
      if ( status === 1 || status === 3 ||  status === 5) {
        setStatus(status + 1);
        setReviewIndex(reviewIndex+1)
      }
    },  widgetData["GoogleReview"]?.UpdateTime*1000);

    const timeout5 = setTimeout(() => {
      if ( status === 2 ||  status === 4) {
        setStatus(status + 1);
        setIgIndex(igIndex+1)
      }
    }, widgetData["Instagram"]?.UpdateTime*1000);

    const timeout4 = setTimeout(() => {
      if ( status === 6) {
        setStatus(1);
        setIgIndex(igIndex+1)
      }
    },widgetData["Instagram"]?.UpdateTime*1000);

    if(index===reviews?.length){
      console.log("index matched");
      setIndex(0)
    }
    if(ind===posts?.length){
      console.log("ind matched");
      setInd(0)
    }

    return () => {
      clearTimeout(timeout2);
      clearTimeout(timeout4);
      clearTimeout(timeout5);
    };
  }, [status, index, reviews,duration]);

  const handleDurationChange = (duration2) => {
    setDuration(duration2)
  };

  const getComment = (encryptedData) => {
    const jsonString = decrypt(encryptedData);
    const jsonObject = JSON.parse(jsonString);
    return jsonObject;
  };

  const getTrimmedComment = (comment) => {
    if (comment?.length > 175) {
      return comment?.slice(0, 175) + '...';
    }
    return comment;
  };

  return (
    <div >
      {showModal && recent.length > 0 && <NewReview layout={branchInfo.Layout} testimonial={getComment(recent[0]?.ReviewComment)?.Comment} name={getComment(recent[0]?.ReviewComment)?.UserInfo?.displayName} star={recent[0].Ratting} profile={getComment(recent[0]?.ReviewComment)?.UserInfo?.profilePhotoUrl} highlight={recent[0].Highlight}/>}
      {showModalInsta && recentInsta.length > 0 && 
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width:"100vw",
        height:"100vh",
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent black
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backdropFilter: 'blur(5px)', // Blur effect
        zIndex: 1000, // Ensure it's above other content
      }}><NewPosts layout={branchInfo.Layout} testimonial={decrypt(recentInsta[0]?.Caption)?.split(' ')?.slice(0, 15).join(' ')} media={recentInsta[0].MediaURL} hashtag={recentInsta[0].HashtagName} name={recentInsta[0].UserName} profile={recentInsta[0].ProfilePictureURL} colorTheme={color} />
      </div>
}
      {loading&&
      // <div style={{
      //   position: 'fixed',
      //   top: 0,
      //   left: 0,
      //   right: 0,
      //   bottom: 0,
      //   width:"100vw",
      //   height:"100vh",
      //   backgroundColor: '#D3D3D3', 
      //   display: 'flex',
      //   justifyContent: 'center',
      //   alignItems: 'center',
      //   backdropFilter: 'blur(5px)', 
      //   zIndex: 1000, 
      // }}>
      //   <img src={loader} width={60}/>
      //   </div>
      <div style={{
        backdropFilter: 'blur(3px)',
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        left: "50%",
        zIndex: 9999,
        height: "100vh",
        width: "100vw",
        transform: "translateX(-50%)",
        backgroundColor: '#D3D3D3',
    }}>
        <img src="https://i.gifer.com/ZZ5H.gif" width={40} />
    </div>
        }
        {widgetData["GoogleQrCode"]?.Count===1&&
<div style={{ position: 'absolute', bottom: '3vh',right:"0.5vw",zIndex:"9999" }}>
<p style={{color:"white",margin:"0vh 0 1vh 0",fontWeight:"600"}}>Scan here</p>
      <QRCode
        value={branchInfo.QRCodeURL}
        size={80}                
        bgColor={"#ffffff"}       
        fgColor={"#000000"}       
        level={"L"}                 
      />
      <p style={{color:"white",margin:"0vh 0 0 0",fontWeight:"600"}}>To Leave us a Review</p>
    </div>
 } 
      {branchInfo.Layout === "Landscape" ? (
    // status === 11 ? (
    //   <LuckyDay layout={branchInfo.Layout}/>
    // ) : 
    //  ( 
     <div>
    <div style={{ position: "absolute", top: 0, left: 0, width: "100vw", height: "100vh", backgroundImage: `url(${branchInfo.BranchBGURL})`, backgroundSize: 'cover', opacity: 0.07 }}></div>
    <div>
        <img src={branchInfo.LogoURL} style={{ height: "5vw", position: "absolute", top: "5vh", left: "50%",transform:"translateX(-50%)" }} />
        {branchInfo.BusinessName ==="Drive X Mobility "?
        <p style={{ color: "white", position: "absolute", left: "8vw", fontSize: "1.9vw",fontWeight:"600",top:"2.5vh",fontStyle:"italic"}}>Ride with Narain</p>
        :
        <p style={{ color: "white", position: "absolute", left: "6vw", fontSize: "1.9vw",fontWeight:"600",top:"2.5vh"}}>{branchInfo.StoreDisplayName}</p>
        }
        {branchInfo.BusinessName ==="Drive X Mobility "?
        <div style={{ display: "flex", flexDirection: "row", gap: "0.5vw", position: "absolute", top: "5.5vh", right: "10vw", borderRadius: "15px", padding: "5px 7px 5px 5px" }}>
          <img src={ig} style={{width:"15vw"}}/>
          </div>
          :
        <div style={{ display: "flex", flexDirection: "row", gap: "0.5vw", position: "absolute", top: "4.5vh", right: "6vw", borderRadius: "15px", padding: "5px 7px 5px 5px" }}>
          <img src={google} alt="Google" style={{ width: "4.5vw", height: "auto" }} />
          <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", gap: "0.5vw", justifyContent: "center" }}>
  {Array(5).fill().map((_, i) => {
    if (i < Math.floor(branchInfo.GoogleAverageRating)) {
      return (
        <div key={i}>
          <FaStar color="gold" size={25} />
        </div>
      );
    } else if (i === Math.floor(branchInfo.GoogleAverageRating)) {
      return (
        <div key={i}>
          <FaStarHalfAlt color="gold" size={25} />
        </div>
      );
    } else {
      return (
        <div key={i}>
          <FaRegStar color="gold" size={25} />
        </div>
      );
    }
  })}
</div>

                {/* <ReviewRating rating={branchInfo.GoogleAverageRating} /> */}
            <p style={{ margin: "0", fontSize: "1.7vw", color: "white",fontWeight:"600" }}>{branchInfo.GoogleAverageRating} stars, {branchInfo.TotalGoogleReviewCount} reviews</p>
          </div>
        </div>
        }
      </div>
      {status ===1 && reviews &&showReviews[reviewIndex] &&<First layout={branchInfo.Layout} testimonial={getTrimmedComment((getComment(showReviews[reviewIndex].ReviewComment))?.Comment)} name={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.displayName} star={showReviews[reviewIndex].Ratting} profile={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.profilePhotoUrl} highlight={showReviews[reviewIndex].Highlight} colorTheme={color} time={ widgetData["GoogleReview"]?.UpdateTime*1000}/>}
      {status ===2 &&posts && showIg[igIndex] && <InstaFourth layout={branchInfo.Layout} testimonial={decrypt(showIg[igIndex]?.Caption)?.split(' ')?.slice(0, 10).join(' ')} media={showIg[igIndex].MediaURL} hashtag={showIg[igIndex].HashtagName} name={showIg[igIndex].UserName} profile={showIg[igIndex].ProfilePictureURL} colorTheme={color} time={widgetData["Instagram"]?.UpdateTime*1000}/>}
      {status === 3&& reviews && showReviews[reviewIndex]&&  <Second layout={branchInfo.Layout} testimonial={getTrimmedComment(getComment(showReviews[reviewIndex].ReviewComment)?.Comment)} name={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.displayName} star={showReviews[reviewIndex].Ratting} profile={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.profilePhotoUrl} highlight={showReviews[reviewIndex].Highlight} colorTheme={color} time={ widgetData["GoogleReview"]?.UpdateTime*1000}/>}
      {status ===4 &&posts && showIg[igIndex] && <InstaFirst layout={branchInfo.Layout} testimonial={decrypt(showIg[igIndex]?.Caption)?.split(' ')?.slice(0, 10).join(' ')} media={showIg[igIndex].MediaURL} hashtag={showIg[igIndex].HashtagName} name={showIg[igIndex].UserName} profile={showIg[igIndex].ProfilePictureURL} colorTheme={color} time={widgetData["Instagram"]?.UpdateTime*1000}/>}
      {status === 5 && showReviews[reviewIndex] && <Fifth layout={branchInfo.Layout} testimonial={getTrimmedComment(getComment(showReviews[reviewIndex].ReviewComment)?.Comment)} name={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.displayName} star={showReviews[reviewIndex].Ratting} profile={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.profilePhotoUrl} highlight={showReviews[reviewIndex].Highlight} colorTheme={color} time={ widgetData["GoogleReview"]?.UpdateTime*1000}/>}
      {status === 6 && posts && showIg[igIndex] && <InstaSecond layout={branchInfo.Layout} testimonial={decrypt(showIg[igIndex]?.Caption)?.split(' ')?.slice(0, 10).join(' ')} media={showIg[igIndex].MediaURL} hashtag={showIg[igIndex].HashtagName} name={showIg[igIndex].UserName} profile={showIg[igIndex].ProfilePictureURL} colorTheme={color} time={widgetData["Instagram"]?.UpdateTime*1000}/>}
     
      {/* {status === 7 && showReviews[3] && <First layout={branchInfo.Layout} testimonial={getComment(showReviews[3].ReviewComment)?.Comment} name={getComment(showReviews[3].ReviewComment)?.UserInfo?.displayName} star={showReviews[3].Ratting} profile={getComment(showReviews[3].ReviewComment)?.UserInfo?.profilePhotoUrl} highlight={showReviews[3].Highlight} colorTheme={color}/>}
      {status === 8 && showIg[3] && <InstaFirst layout={branchInfo.Layout} testimonial={decrypt(showIg[3]?.Caption)?.split(' ').slice(0, 15).join(' ')} media={showIg[3].MediaURL} hashtag={showIg[3].HashtagName} name={showIg[3].UserName} profile={showIg[3].ProfilePictureURL} colorTheme={color}/>}
      {status === 9 && reviews && showReviews[4] && <Fifth layout={branchInfo.Layout} testimonial={getComment(showReviews[4]?.ReviewComment)?.Comment} name={getComment(showReviews[4]?.ReviewComment)?.UserInfo?.displayName} star={showReviews[4].Ratting} profile={getComment(showReviews[4]?.ReviewComment)?.UserInfo?.profilePhotoUrl} highlight={showReviews[4].Highlight} colorTheme={color}/>} */}
      
      {/* {status ===12 && showUgc[0]&& <VideoAds video={c1}  onDurationChange={handleDurationChange}/>}
      {status ===13 &&showUgc[1]&& <VideoAds video={c2}  onDurationChange={handleDurationChange}/>}

      {status ===10 && video && video[0] && <UGC layout={branchInfo.Layout} testimonial={decrypt(video[0]?.Caption)?.split(' ').slice(0, 15).join(' ')} media={content} hashtag={video[0].HashtagName} name={video[0].UserName} profile={video[0].ProfilePictureURL}  onDurationChange={handleDurationChange}/>} */}
      {/* {status ===11 && ugc && ugc[1] && <UGC layout={branchInfo.Layout} testimonial={decrypt(video[1]?.Caption)?.split(' ').slice(0, 15).join(' ')} media={ugc[1].ContentURL} hashtag={video[0].HashtagName} name={video[0].UserName} profile={video[0].ProfilePictureURL}  />} */}
    </div>
    // )
  ):
    ( 
    <div>
     {/* { status === 11 ? (
      <LuckyDay layout={branchInfo.Layout}/>
    ) :
    ( */}
    <div>
    <div style={{ position: "absolute", top: 0, left: 0, width: "100vw", height: "100vh", backgroundImage: `url(${branchInfo.BranchBGURL})`, backgroundSize: 'cover', opacity: 0.07 }}></div>
    <div>
        <img src={branchInfo.LogoURL} style={{ height: "10vw", position: "absolute", bottom: "1vh", left: "50%",transform:"translateX(-50%)" }}/>
        {branchInfo.BusinessName ==="Drive X Mobility "?
         <p style={{ color: "white", position: "absolute", left: "6vw", fontSize: "3.5vw",fontWeight:"600",width:"45%",top:"1vh",fontStyle:"italic" }}>Ride with Narain</p>
          :
        <p style={{ color: "white", position: "absolute", left: "6vw", fontSize: "3.5vw",fontWeight:"600",width:"45%",top:"1vh" }}>{branchInfo.StoreDisplayName}</p>
        }
        {branchInfo.BusinessName ==="Drive X Mobility "?
        <div style={{ display: "flex", flexDirection: "row", gap: "0.5vw", position: "absolute", top: "3.5vh", right: "8vw", borderRadius: "15px", padding: "5px 7px 5px 5px" }}>
           <img src={ig} style={{width:"19vw"}}/>
          </div>
          :
        <div style={{ display: "flex", flexDirection: "row", gap: "0.5vw", position: "absolute", top: "2vh", right: "6vw", borderRadius: "15px", padding: "5px 7px 5px 5px" }}>
          <img src={google} alt="Google" style={{ width: "8vw", height: "auto" }} />
          <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ display: "flex", gap: "0.5vw", justifyContent: "center" }}>
  {Array(5).fill().map((_, i) => {
    if (i < Math.floor(branchInfo.GoogleAverageRating)) {
      return (
        <div key={i}>
          <FaStar color="gold" size={25} />
        </div>
      );
    } else if (i === Math.floor(branchInfo.GoogleAverageRating)) {
      return (
        <div key={i}>
          <FaStarHalfAlt color="gold" size={25} />
        </div>
      );
    } else {
      return (
        <div key={i}>
          <FaRegStar color="gold" size={25} />
        </div>
      );
    }
  })}
</div>

                {/* <ReviewRating rating={branchInfo.GoogleAverageRating} /> */}
            <p style={{ margin: "0", fontSize: "3vw", color: "white",fontWeight:"600" }}>{branchInfo.GoogleAverageRating} stars, {branchInfo.TotalGoogleReviewCount} reviews</p>
          </div>
        </div>
        }
      </div>
     
      {status ===1 && reviews &&showReviews[reviewIndex] &&<First layout={branchInfo.Layout} testimonial={getComment(showReviews[reviewIndex].ReviewComment)?.Comment} name={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.displayName} star={showReviews[reviewIndex].Ratting} profile={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.profilePhotoUrl} highlight={showReviews[reviewIndex].Highlight} colorTheme={color} time={ widgetData["GoogleReview"]?.UpdateTime*1000}/>}
      {status ===2 &&posts && showIg[igIndex] && <InstaFourth layout={branchInfo.Layout} testimonial={decrypt(showIg[igIndex]?.Caption)?.split(' ')?.slice(0, 10).join(' ')} media={showIg[igIndex].MediaURL} hashtag={showIg[igIndex].HashtagName} name={showIg[igIndex].UserName} profile={showIg[igIndex].ProfilePictureURL} colorTheme={color} time={ widgetData["Instagram"]?.UpdateTime*1000}/>}
      {status === 3&& reviews && showReviews[reviewIndex]&&  <Second layout={branchInfo.Layout} testimonial={getComment(showReviews[reviewIndex].ReviewComment)?.Comment} name={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.displayName} star={showReviews[reviewIndex].Ratting} profile={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.profilePhotoUrl} highlight={showReviews[reviewIndex].Highlight} colorTheme={color} time={ widgetData["GoogleReview"]?.UpdateTime*1000}/>}
      {status ===4 &&posts && showIg[igIndex] && <InstaFirst layout={branchInfo.Layout} testimonial={decrypt(showIg[igIndex]?.Caption)?.split(' ')?.slice(0, 15).join(' ')} media={showIg[igIndex].MediaURL} hashtag={showIg[igIndex].HashtagName} name={showIg[igIndex].UserName} profile={showIg[igIndex].ProfilePictureURL} colorTheme={color} time={ widgetData["Instagram"]?.UpdateTime*1000}/>}
      {status === 5 && showReviews[reviewIndex] && <Fifth layout={branchInfo.Layout} testimonial={getComment(showReviews[reviewIndex].ReviewComment)?.Comment} name={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.displayName} star={showReviews[reviewIndex].Ratting} profile={getComment(showReviews[reviewIndex].ReviewComment)?.UserInfo?.profilePhotoUrl} highlight={showReviews[reviewIndex].Highlight} colorTheme={color} time={ widgetData["GoogleReview"]?.UpdateTime*1000}/>}
      {status === 6 && posts && showIg[igIndex] && <InstaSecond layout={branchInfo.Layout} testimonial={decrypt(showIg[igIndex]?.Caption)?.split(' ')?.slice(0, 15).join(' ')} media={showIg[igIndex].MediaURL} hashtag={showIg[igIndex].HashtagName} name={showIg[igIndex].UserName} profile={showIg[igIndex].ProfilePictureURL} colorTheme={color} time={ widgetData["Instagram"]?.UpdateTime*1000}/>}
     
      {/* {status ===11 && ugc && ugc[1] && <UGC layout={branchInfo.Layout} video={ugc[1]?.ContentURL} />} */}
    </div>
  {/* )}  */}
    </div>
  )}
    </div>
  );
}

export default NewLayout;
